import React from 'react';
import classnames from 'classnames';
import { Spinner } from '@reservation-app/common-used-in-web';
export const LoadingPage = ({ containerClassName }) => {
    return (React.createElement("div", { className: classnames('fixed bottom-0 top-0 left-0 right-0 flex items-center justify-center', containerClassName) },
        React.createElement(Spinner, { className: classnames('w-6 h-6 text-primary-main') })));
};
